import ctl from "@netlify/classnames-template-literals";

/**
 * This file contains the shared styles for all the input components.
 * For example: Input, Select, Autocomplete, etc.
 */
export const transitionProps = {
  enter: "transition ease duration-500 transform",
  enterFrom: "opacity-0 -translate-y-2",
  enterTo: "opacity-100 translate-y-0",
  leave: "transition ease duration-300 transform",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 -translate-y-2",
};

export const inputGroup = ctl(`
  flex
  flex-col
  w-full
`);

export const label = ctl(`
  flex
  items-center
  mb-2
  ml-2
  cursor-pointer
  text-base
  text-neutral-900
  font-bold
`);

export const labelDark = ctl(`
  !text-white
`);

export const labelRequired = ctl(`
  text-neutral-600
`);

export const labelRequiredDark = ctl(`
  !text-white
`);

export const labelDisabled = ctl(`
  !text-neutral-500
`);

const inputBase = ctl(`
  w-full
  rounded-2xl
  border
  px-4
  py-3
  flex
  items-center
  justify-between
  outline-none
  transition-all
  duration-200
`);

export const input = ctl(`
  ${inputBase}
  border-neutral-300
  text-neutral-900
  bg-white
  caret-purple-900
  placeholder:text-neutral-500
  active:border-neutral-600
  active:bg-neutral-50
  active:placeholder-transparent
  focus:border-neutral-600
  focus:bg-neutral-50
  focus:placeholder-transparent
  focus:ring-0
`);

export const inputDark = ctl(`
 ${inputBase}
  !border-transparent
  !bg-neutral-850
  text-white
  caret-green-500
  placeholder:text-neutral-400
  active:bg-neutral-850
  focus:bg-neutral-850
  active:border-transparent
  focus:border-white
  focus:ring-1
  focus:ring-white
  focus:ring-offset-0.5
  focus:ring-offset-transparent
  disabled:bg-neutral-850
  disabled:border-transparent
  disabled:text-neutral-500
`);

export const inputDarkOutlined = ctl(`
 ${inputBase}
  border-1
  border-neutral-700
  bg-neutral-800 
  text-white
  caret-green-500
  placeholder:text-neutral-400
  active:bg-neutral-800
  focus:bg-neutral-800
  active:border-neutral-600
  focus:border-white
  focus:ring-1
  focus:ring-white
  focus:ring-offset-0.5
  focus:ring-offset-transparent
  disabled:bg-neutral-800
  disabled:border-transparent
  disabled:text-neutral-500
`);

export const inputDisabled = ctl(`
  disabled:bg-neutral-50
  disabled:border-neutral-300
  disabled:text-neutral-500
  disabled:pointer-events-none
`);

export const inputError = ctl(`
  !border-1
  !border-status-red-500
  focus:!border-status-red-500
  active:!border-status-red-500
  focus:!ring-status-red-500
`);

export const icon = ctl(`
  absolute
  bottom-1/2
  translate-y-1/2
  text-purple-500
`);

export const iconError = ctl(`
  text-status-red-500
`);

export const iconDisabled = ctl(`
  !text-neutral-500
`);

export const helperText = ctl(`
  mt-2
  ml-2
  text-sm
  text-neutral-600
`);

export const helperTextDark = ctl(`
  !text-neutral-200
`);

export const errorText = ctl(`
  mt-2
  ml-2
  text-sm
  text-neutral-600
  text-status-red-500
`);

export const errorTextDark = ctl(`
  !text-status-red-500
`);

export const helperTextDisabled = ctl(`
  !text-neutral-400
`);

export const selectButtonDisabled = ctl(`
  bg-neutral-50
  border-neutral-300
  text-neutral-500
  pointer-events-none
`);

export const selectMenu = ctl(`
  absolute
  z-20
  top-2
  w-full
  rounded-2xl
  border
  border-neutral-300
  bg-white
  text-neutral-900
  flex
  flex-col
  outline-none
  transition-all
  duration-200
  max-h-[14rem]
  overflow-y-auto
`);

export const selectMenuDark = ctl(`
  ${selectMenu}
  !border-neutral-700
  !bg-neutral-800
  text-white
`);

export const datePickerDateButton = ctl(`
  relative
  flex
  w-[331px]
  items-stretch
  align-middle
`);

export const DayPickerMenu = ctl(`
  absolute
  z-40
  top-2
  rounded-lg
  border
  border-neutral-600
  bg-white
  text-neutral-900
  flex
  flex-col
  outline-none
  transition-all
  duration-200
  overflow-visible
`);

export const selectMenuItem = ctl(`
  flex
  items-center
  justify-between
  px-4
  py-3
  border-b
  border-neutral-300
  cursor-pointer
  hover:bg-neutral-50
  last:border-b-0
`);

export const selectMenuItemDark = ctl(`
 ${selectMenuItem}
  border-none
  hover:bg-neutral-700
  selected:bg-neutral-700
`);

export const selectMultiItem = ctl(`
  flex
  items-center
  justify-between
  px-4
  py-3
  cursor-pointer
  hover:bg-neutral-50
`);
